import React, { forwardRef, useEffect, useRef } from "react";
import useSound from "~/hooks/use-sound";
import { useGeneralStore } from "~/stores/use-general-store";
import type { ButtonProps } from "./button";

const AudioButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const { buttonSoundEnabled } = useGeneralStore();
  const { playSound } = useSound();

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.2;
    }
  }, [audioRef]);

  return (
    <button
      {...props}
      ref={ref}
      onPointerDown={(e) => {
        if (props.onPointerDown) {
          props.onPointerDown(e);
        }

        if (buttonSoundEnabled) {
          playSound(audioRef);
        }
      }}
    >
      {props.children}
      <audio ref={audioRef} preload="auto" />
    </button>
  );
});

export default AudioButton;
